import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=a2324d38&scoped=true&lang=pug&"
import script from "./Anexos.vue?vue&type=script&lang=js&"
export * from "./Anexos.vue?vue&type=script&lang=js&"
import style0 from "./Anexos.vue?vue&type=style&index=0&id=a2324d38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2324d38",
  null
  
)

export default component.exports